import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { cloneDeep } from "lodash";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import MaterialUnitGroupCreateDialog from "../dialogTypes/MaterialUnitGroupCreateDialog";
/**
 * @COMPONENT_NAME CreateMaterialUnitGroupButton
 * @DESCRIPTION 자재 단위 그룹 생성을 위한 커스텀 버튼 컴포넌트
 *             자재 단위 그룹을 생성할 수 있는 다이얼로그를 표시
 *
 * @PROPS
 *   - {string} id - 컴포넌트 ID
 *   - {Object} schema - 테이블 스키마 정보
 *   - {Object} refresh - API refresh 객체
 *   - {Function} onSuccess - 성공 시 콜백
 *   - {...any} others - 기타 props
 *
 * @CALLBACKS
 *   - {Function} onOpen - 버튼 클릭 시 호출되는 콜백
 *   - {Function} onClose - 다이얼로그 닫기 시 호출되는 콜백
 *   - {Function} onCreateSuccess - 생성 성공 시 호출되는 콜백
 */
function CreateMaterialUnitGroupButton(props) {
    const { t } = useTranslation();

    const { id, schema, refresh, onSuccess, ...others } = props;

    const [open, setOpen] = useState(false);
    const [modifiedSchema, setModifiedSchema] = useState();

    useEffect(() => {
        if (schema) {
            const newSchema = cloneDeep(schema);
            // newSchema.columns.push({
            //     name: "baseUnitSymbol",
            //     formItemType: "text",
            //     width: "100%",
            //     disabled: true,
            //     formOrder: 35,
            //     formGroup: 0,
            // });
            setModifiedSchema(newSchema);
        }
    }, [schema]);

    const onOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onCreateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg);
        }

        if (refresh) {
            refresh.refresh();
        }
    };

    const setInitialDataCallback = (formData) => {};

    const modifyFormDataCallback = (formData, name, value) => {};

    const checkFormValidationCallback = (formData) => {};

    return (
        <>
            <CreateRecordButtonLayout id={id + "create-button"} onClick={onOpen} {...others} />
            <MaterialUnitGroupCreateDialog
                id={id + "create-dialog"}
                mode="create"
                formId={id + "create-form"}
                title={schema ? t(`dialog.title.${schema.name}.create`) : ""}
                schema={modifiedSchema}
                initialData={undefined}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
                setInitialDataCallback={setInitialDataCallback}
                modifyFormDataCallback={modifyFormDataCallback}
                checkFormValidationCallback={checkFormValidationCallback}
            />
        </>
    );
}

export default CreateMaterialUnitGroupButton;
